<template>
  <div>
    <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Formulário de Dieta</h1>
    <data-table
      v-if="loadTable"
      v-model:columns="columns"
      :route="'/patients/diet-forms/' + patient.id"
      no-data-label="Nenhum formulário de dieta cadastrado"
      no-result-label="Nenhum formulário de dieta encontrado"
    >
      <template #table.cell.content.actions="{ value, row }">
        <div class="inline-grid grid-cols-2 gap-4 ">
          <span v-if="user.role == 1 || row.professional_id == user.professional.id" @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
          <span v-if="user.role == 1 || row.professional_id == user.professional.id" @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
        </div>
      </template>
      <template #grid.content.body.actions="{ value, row }">
        <div class="inline-grid grid-cols-2 gap-4 ">
          <span v-if="user.role == 1 || row.professional_id == user.professional.id" @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
          <span v-if="user.role == 1 || row.professional_id == user.professional.id" @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
        </div>
      </template>

      <template #after.reload-button>
        <button v-if="user.role == 2" class="flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="openModalEdit({})">
          <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block"> Adicionar Formulário de Dieta</span>
        </button>
      </template>
    </data-table>
  </div>
  <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
  <modal-edit ref="modalEdit" title="Formulário de Dieta" :url="'patients/diet-forms/' + patient.id" @submitForm="reloadTable">
    <template #form="{item}">
      <text-input v-model="item.name" :error="item.errors.name" class="w-full" label="Nome" />
      <vue-select-input v-if="user.role == 1" :getOptionLabel="(professional) => professional.user?.name" v-model="item.professional" :options="this.professionals()" :error="item.errors[`professional.id`]" class="mt-6 w-full" label="Profissional" text="nenhum profissional encontrado" />
      <date-input v-model="item.date_start" :error="item.errors.date_start" class="mt-6 lg:pr-6 w-full lg:w-1/2" label="Data de Início" />
      <date-input v-model="item.date_end" :error="item.errors.date_end" class="mt-6 w-full lg:w-1/2" label="Data Final" />
      <textarea-input v-model="item.description" :error="item.errors.description" class="mt-6 w-full" label="Descrição" />
      
      <button class="mt-6 flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="item.meals.push({day: null, meal: null, foods: []});">
        <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /> Adicionar Refeição
      </button>
      <div class="w-full flex flex-wrap p-6 mt-4 bg-gray-100/50" v-for="(meal, meal_index) in item.meals">
        <select-input v-model="meal.day" :error="item.errors[`meals.`+meal_index+`.day`]" class="lg:pr-6 w-full lg:w-5/12" placeholder="Dia">
          <option :value="null" disabled class="hidden invisible">Dia</option>
          <option v-for="(value, name, index) in this.diet_form_meal_days()" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <select-input v-model="meal.meal" :error="item.errors[`meals.`+meal_index+`.meal`]" class="mt-6 lg:mt-0 lg:pr-6 w-5/6 lg:w-6/12" placeholder="Refeição">
          <option :value="null" disabled class="hidden invisible">Refeição</option>
          <option v-for="(value, name, index) in this.diet_form_meal_meals()" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <div class="mt-6 lg:mt-0 w-1/6 lg:w-1/12 self-center text-right">
          <span @click="deleteMeal(item, meal)"><font-awesome-icon icon="fa-xmark" class="text-gray-600 text-lg cursor-pointer" /></span>
        </div>

        <div class="w-full flex flex-wrap">
          <button class="flex items-end font-roboto font-medium btn-blue uppercase text-xs px-3 py-2 mt-4 mb-3" @click.prevent="meal.foods.push({unity: null, goal: {}});">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /> Adicionar Alimento
          </button>
          <div class="w-full flex flex-wrap p-2 mt-1 bg-gray-100/75" v-for="(food, food_index) in meal.foods">
            <vue-select-input v-model="food.food" :options="this.foods()" :error="item.errors[`meals.`+meal_index+`.foods.`+food_index+`.food.id`]" class="lg:pr-6 w-full lg:w-4/12" placeholder="Alimento" text="nenhum alimento encontrado" />
            <select-input v-model="food.unity" :error="item.errors[`meals.`+meal_index+`.foods.`+food_index+`.unity`]" class="mt-6 lg:mt-0 lg:pr-6 w-full lg:w-4/12" placeholder="Unidade">
              <option :value="null" disabled class="hidden invisible">Unidade</option>
              <option v-for="(value, name, index) in this.diet_form_meal_unitys()" :key="name" :value="name">{{ value }}</option>
            </select-input>
            <mask-input mask="#####" v-model="food.quantity" :error="item.errors[`meals.`+meal_index+`.foods.`+food_index+`.quantity`]" class="mt-6 lg:mt-0 lg:pr-6 w-5/6 lg:w-3/12" placeholder="Quantidade" />
            <div class="mt-6 lg:mt-0 w-1/6 lg:w-1/12 self-center text-right">
              <span @click="deleteMealFood(meal, food)"><font-awesome-icon icon="fa-xmark" class="text-gray-600 text-lg cursor-pointer" /></span>
            </div>
          </div>
        </div>
      </div>

    </template>
  </modal-edit>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import DataTable from '@/Shared/DataTable'
import SwitchInput from '@/Shared/SwitchInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import DateInput from '@/Shared/DateInput'
import VueSelectInput from '@/Shared/VueSelectInput'
import MaskInput from '@/Shared/MaskInput'
import TextareaInput from '@/Shared/TextareaInput'

export default {
  inject: ['patient', 'professionals', 'foods', 'diet_form_meal_meals', 'diet_form_meal_days', 'diet_form_meal_unitys'],
  components: {
    LoadingButton,
    ModalDelete,
    ModalEdit,
    DataTable,
    SwitchInput,
    TextInput,
    SelectInput,
    DateInput,
    VueSelectInput,
    MaskInput,
    TextareaInput,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  data() {
    return {
      loadTable: true,
      columns: [
        {
          uniqid: 'diet_form_name',
          label: 'Nome',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm overflow-hidden',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? row.name : ''
        },
        {
          uniqid: 'diet_form_description',
          label: 'Descrição',
          field: 'description',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm overflow-hidden',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? val.substr(0, 50) : ''
        },
        {
          uniqid: 'diet_form_date_start',
          label: 'Data Inicial',
          field: 'date_start',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDate(row.date_start),
        },
        {
          uniqid: 'diet_form_date_end',
          label: 'Data Final',
          field: 'date_end',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDate(row.date_end),
        },
        {
          uniqid: 'diet_form_professional',
          label: 'Profissional',
          field: 'professional_user.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.id ? row.professional.user.name : ''
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: this.user.role == 2 ? true : false,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/patients/diet-forms/${item.id}`, `Deseja realmente excluir o formulário de dieta ${item.goal}?`);
    },
    openModalEdit(i) {
      this.$refs.modalEdit.openModalEdit({
        id: i.id,
        name: i.name,
        description: i.description,
        date_start: i.date_start,
        date_end: i.date_end,
        professional: i.professional ?? null,
        meals: i.meals ?? [],
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    deleteMeal(form, meal) {
      form.meals.splice(form.meals.indexOf(meal), 1);
    },
    deleteMealFood(meal, food) {
      meal.foods.splice(meal.foods.indexOf(food), 1);
    },
  },
}
</script>